import { Component, OnInit, ChangeDetectorRef } from "@angular/core";
import { Contact } from "../../interfaces/contact";
import { Link } from "../../interfaces/link";
import { WordpressService } from "../../services/wordpress.service";

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {
  contact: Contact;
  socialLinks: Link[] = [];

  constructor(private wp: WordpressService, private cdr: ChangeDetectorRef) {
    this.wp.getContact().subscribe((res) => {
      this.contact = res ? res.acf : null;
      this.setSocialLinks();
    });
  }

  setSocialLinks() {
    if (this.contact && this.contact.social_links) {
      if (this.contact.social_links.instagram_url) {
        this.socialLinks.push({
          title: 'insta',
          url: this.contact.social_links.instagram_url
        });
      }

      if (this.contact.social_links.facebook_url) {
        this.socialLinks.push({
          title: 'fb',
          url: this.contact.social_links.facebook_url
        });
      }

      if (this.contact.social_links.twitter_url) {
        this.socialLinks.push({
          title: 'twtr',
          url: this.contact.social_links.twitter_url
        });
      }
    }
  }

  ngOnInit() {}
}
